module.exports = __webpack_public_path__ + "img/selfAdhesive7.88359a47.jpg";